const updates = [
  { time: '10分钟前', title: '某顶流男星深夜与神秘女子同回酒店，视频监控画面曝光', tag: '劲爆', hot: true },
  { time: '28分钟前', title: '知名女团成员疑似恋情曝光，男方身份被扒系圈外富商', tag: '新料', hot: true },
  { time: '1小时前', title: '某综艺节目录制现场发生冲突，两位嘉宾当场翻脸离场', tag: '独家', hot: false },
  { time: '2小时前', title: '一线女星前夫再爆猛料，万字长文揭露婚姻内幕细节', tag: '跟进', hot: true },
  { time: '3小时前', title: '某知名导演被多名演员联合举报，业内震动持续发酵', tag: '重磅', hot: false },
  { time: '5小时前', title: '当红小生税务问题再起波澜，官方回应疑点重重引猜测', tag: '争议', hot: false },
  { time: '7小时前', title: '网红主播带货翻车，消费者集体维权事件最新进展', tag: '热点', hot: false },
  { time: '9小时前', title: '某女星整容前后对比照流出，本人深夜发文回应质疑', tag: '吃瓜', hot: false },
  { time: '12小时前', title: '热门电视剧剧组内部矛盾曝光，多位主创被爆不和', tag: '深扒', hot: false },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-7 bg-primary-500 rounded-full"></div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">最新快讯</h2>
          <span className="text-xs text-foreground-500 bg-background-200 px-2.5 py-1 rounded-full">实时更新</span>
        </div>

        <div className="space-y-0">
          {updates.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-start gap-3 md:gap-4 py-3.5 border-b border-background-200/60 last:border-0 group cursor-pointer hover:bg-background-200/40 transition-colors -mx-2 px-2 rounded-lg ${
                idx === 0 ? 'pt-0' : ''
              }`}
            >
              <div className="flex items-center gap-2 min-w-[110px] md:min-w-[130px] pt-0.5">
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                <span
                  className={`text-[10px] px-1.5 py-0.5 rounded whitespace-nowrap font-medium ${
                    item.hot
                      ? 'bg-primary-500/15 text-primary-500'
                      : 'bg-background-300 text-foreground-500'
                  }`}
                >
                  {item.tag}
                </span>
              </div>

              <div className="flex items-center gap-2 flex-1 min-w-0">
                <div className="w-1.5 h-1.5 rounded-full bg-primary-500 shrink-0 mt-2 hidden md:block"></div>
                <p className="text-sm md:text-base text-foreground-700 group-hover:text-primary-500 transition-colors leading-relaxed line-clamp-1">
                  {item.title}
                </p>
              </div>

              {item.hot && (
                <span className="shrink-0 text-[10px] text-primary-500 flex items-center gap-1 whitespace-nowrap">
                  <i className="ri-fire-fill text-xs"></i>热
                </span>
              )}
            </div>
          ))}
        </div>

        <div className="mt-6 text-center">
          <a
            href="#index"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-1.5 text-sm text-accent-500 hover:text-accent-600 transition-colors cursor-pointer"
          >
            查看更多黑料
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}